// extracted by mini-css-extract-plugin
export default {"container":"DoctorList_container__cH6K5","logo":"DoctorList_logo__4PKGs","list":"DoctorList_list__UVNRe"};